import BaseService from "./base.service";
import http from "../http-common";
import { getResponseData } from "@helpers/_functions";
class SalaryAndAdvantage extends BaseService {
  constructor() {
    super("salary-and-advantage");
  }
  bulkUpdateSalaryAndAdvantages(payload) {
    return http.put(`${this.path}/bulk-update-salary-and-advantage`, payload)
      .then((response) => getResponseData(response));
  }
}

export default new SalaryAndAdvantage();
